<template>
  <div class="proposal__wrap">
    <div class="fdfdf crumbs__wrap">
      <el-button
        class="backBtn"
        @click="$router.go(-1)"
        plain
        icon="el-icon-d-arrow-left"
        size="mini"
        >返回</el-button
      >
      &nbsp;&nbsp;&nbsp;
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/agent' }"
          >代理管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>业务员列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params">
        <el-form-item label="代理" prop="agent_id">
          <el-select
            clearable
            filterable
            v-model="table.params.agent_id"
            placeholder=""
          >
           <el-option
              v-for="item in agentList_"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
              >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="name">
          <el-input
            clearable
            v-model="table.params.name"
            placeholder="业务员姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="phone">
          <el-input
            clearable
            v-model="table.params.phone"
            placeholder="业务员手机号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch"
            >查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:num="{ row }">
          <el-button type="text" @click="pushPage(row)">{{
            row.num
          }}</el-button>
        </template>
        <template v-slot:action="{ row }">
          <el-button
            type="text"
            icon="el-icon-delete"
            class="delBtn"
            @click="handleDelete(row)"
            >删除</el-button
          >
        </template>
      </VTable>
    </div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "SalesmanList",
  mixins: [mixinTable],
  components: {
    VTable,
  },
  data() {
    return {
      field: [
        { name: "nickname", label: "业务员名称", hidden: false },
        { name: "account", label: "手机号", hidden: false },
        { name: "school_name", label: "推广学校", hidden: false },
        { name: "num", label: "推广人数", hidden: false },
        { name: "create_time", label: "添加时间", hidden: false },
        { name: "action", label: "操作", width: "160", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          name: "",
          phone: "",
          agent_id: Number(sessionStorage.getItem("agentId")),
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      agentList_:[],
    };
  },
  created() {
    this.getAgentList();
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("/admin/salesman/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 删除
    handleDelete(row) {
      this.$confirm("请确认删除操作?", "提示", {
        type: "warning",
        showCancelButton: true,
      })
        .then(() => {
          this.$http.post("/admin/salesman/del", { id: row.id }).then((res) => {
            if (res.code === 1) {
              this.$message.success("删除成功");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    pushPage(row) {
      this.$router.push({
        path: "/student/index1",
        query: { id: row.id, agent_id: this.table.params.agent_id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }

  .crumbs__wrap {
    margin-bottom: 20px;
  }
}
.fdfdf {
  display: flex;
  align-items: center;
}
</style>